import mapValues from 'lodash/mapValues';
import { LocalityCommonDistrict, LocalityCommonRegion, LocalityType } from '@domain-group/fe-allhomes-library/lib/node';
import { toInteger } from '../../utils/conversions';
import { mergeLocalities } from '../../utils';
import Filters, { toLocality } from '../filters';
var _mapValues = mapValues(LocalityType, each => each.type),
  DISTRICT = _mapValues.DISTRICT,
  REGION = _mapValues.REGION;
var isCbr = locality => locality.type === REGION && toInteger(locality.id) === LocalityCommonRegion.CANBERRA.regionId;
var isQbn = locality => locality.type === DISTRICT && toInteger(locality.id) === LocalityCommonDistrict.GREATER_QUEANBEYAN.districtId;

/**
 * A special Filters subclass that includes the Greater Queanbeyan district in the
 * search if the Canberra Region is included in the location filter.
 */
class QbnInCbrSpecialFilter extends Filters {
  constructor(listingType, valuesParam) {
    super(listingType, valuesParam);
    var singleLocality = this.getSingleLocality() || {};
    if (isCbr(singleLocality)) {
      this.localities = mergeLocalities(this.localities, toLocality(LocalityType.DISTRICT.type, LocalityCommonDistrict.GREATER_QUEANBEYAN.districtId));
    }
  }
  cloneWith() {
    for (var _len = arguments.length, newValues = new Array(_len), _key = 0; _key < _len; _key++) {
      newValues[_key] = arguments[_key];
    }
    return new QbnInCbrSpecialFilter(this.listingType, Object.assign({}, this.getValues(), ...newValues));
  }
  getSingleLocality() {
    var singleLocality = super.getSingleLocality();
    if (singleLocality) {
      return singleLocality;
    }
    var localities = this.getLocalities() || [];
    if (localities.length === 2) {
      var canberraRegion = localities.find(isCbr);
      var queanbeyanDistrict = localities.find(isQbn);
      if (canberraRegion && queanbeyanDistrict) {
        return canberraRegion;
      }
    }
    return undefined;
  }
}
export default QbnInCbrSpecialFilter;